exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button--medium[data-v-2bda9544]{padding:9px 20px!important}", ""]);

// exports
